import classNames from '../../_util/classNames';
export default function getRanges({ prefixCls, rangeList = [], components = {}, needConfirmButton, onNow, onReset, onOk, okDisabled, showNow, showReset, locale, }) {
    let resetNode;
    let presetNode;
    let okNode;
    if (rangeList.length) {
        const Item = (components.rangeItem || 'span');
        presetNode = (<>
        {rangeList.map(({ label, onClick, onMouseenter, onMouseleave }) => (<li key={label} class={`${prefixCls}-preset`}>
            <Item onClick={onClick} onMouseenter={onMouseenter} onMouseleave={onMouseleave}>
              {label}
            </Item>
          </li>))}
      </>);
    }
    if (needConfirmButton) {
        const Button = (components.button || 'button');
        if (onNow && !presetNode && showNow !== false) {
            presetNode = (<li class={`${prefixCls}-now`}>
          <Button class={`${prefixCls}-now-btn`} onClick={onNow} size="extra-small" type="secondary">
            {locale.now}
          </Button>
        </li>);
        }
        if (onReset && showReset) {
            resetNode = (<li class={`${prefixCls}-reset`}>
          <Button disabled={okDisabled} onClick={onReset} size="extra-small" type="secondary">
            {locale.reset}
          </Button>
        </li>);
        }
        okNode = needConfirmButton && (<li class={`${prefixCls}-ok`}>
        <Button disabled={okDisabled} onClick={onOk} size="extra-small" type="primary">
          {locale.ok}
        </Button>
      </li>);
    }
    if (!presetNode && !resetNode && !okNode) {
        return null;
    }
    return (<ul class={classNames({
            [`${prefixCls}-ranges`]: true,
            [`${prefixCls}-ranges-hasreset`]: needConfirmButton && onReset && showReset,
        })}>
      {presetNode}
      {resetNode}
      {okNode}
    </ul>);
}
